const url = {
	API_BASE_URL: 'https://admin.hi-techservices.co.in/api/'
};
export const server_config = url;
